"use strict";
HTMLElement.prototype.getHeight = function getHeight(type) {
    type = type !== null && type !== void 0 ? type : 'css';
    const compStyle = window.getComputedStyle(this);
    let height;
    switch (type) {
        case 'css':
            height = this.clientHeight;
            height -= parseInt(compStyle.paddingTop || '0');
            height -= parseInt(compStyle.paddingBottom || '0');
            return height;
        case 'inner':
            return this.clientHeight;
        case 'outer':
            return this.offsetHeight;
        case 'outer-margin':
            height = this.offsetHeight;
            height += parseInt(compStyle.marginTop || '0');
            height += parseInt(compStyle.marginBottom || '0');
            return height;
    }
    /* istanbul ignore next */
    return 0;
};
//# sourceMappingURL=GetHeight.js.map